
const ErrorService = {
  getErrorMessage: (error: any) => {
    // this function can be expanded to handle different languages
    return error.message || 'An unknown error occurred';
  },

  mapBackendErrors: (error: any) => {
    const errors: { [key: string]: string } = {};
    if (error.errors) {
      for (const key in error.errors) {
        errors[key] = error.errors[key].join(', ');
      }
    }
    return errors;
  },
};

export default ErrorService;

